
import { Component, Prop, Element, h } from '@stencil/core';

@Component({
  tag: 'lar-debug-content',
  shadow: false,
  scoped: false
})
export class DebugContent {
  /**
   * Component JSON text
   */
  @Prop() text?: string;

  render() {
    return [
      <div><pre>{JSON.stringify(this.text, null, 2)}</pre></div>
    ];
  }
}